export default (headers, key) => {
  return headers.find(item => item.value.toLowerCase() === key.toLowerCase());
};
